// extracted by css-extract-rspack-plugin
export default {"ConfirmDialog":"ConfirmDialog-A55nBH","confirmDialog":"ConfirmDialog-A55nBH","large-button":"large-button-eCYJgO","largeButton":"large-button-eCYJgO"};